import { RootState } from '@store';

export const selectIsFactoryOrder = (state: RootState) => {
  return state.appOrder?.isFactoryOrder;
};
